import { render, staticRenderFns } from "./BikLoadDataContainer.vue?vue&type=template&id=24a397c9&"
import script from "./BikLoadDataContainer.vue?vue&type=script&lang=js&"
export * from "./BikLoadDataContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports